import { render, staticRenderFns } from "./quotation-detail.vue?vue&type=template&id=6316c153&scoped=true"
import script from "./quotation-detail.vue?vue&type=script&lang=js"
export * from "./quotation-detail.vue?vue&type=script&lang=js"
import style0 from "./quotation-detail.vue?vue&type=style&index=0&id=6316c153&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6316c153",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6316c153')) {
      api.createRecord('6316c153', component.options)
    } else {
      api.reload('6316c153', component.options)
    }
    module.hot.accept("./quotation-detail.vue?vue&type=template&id=6316c153&scoped=true", function () {
      api.rerender('6316c153', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/quotation-apply-sup/quotation-detail.vue"
export default component.exports